// components/FunnelRoute.jsx
import React from 'react';
import useFunnelComponent from '../hooks/FunnelComponent';
import LoaderInline from './LoaderInline';
import * as Sentry from "@sentry/react";

const FunnelRoute = ({ componentName }) => {
  const { Component, loading, error } = useFunnelComponent(componentName);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoaderInline text={`Loading ${componentName}...`} />
      </div>
    );
  }

  if (error) {
    Sentry.captureException(error, {
      extra: { componentName: componentName }
    });
    
    const isChunkError = error.message?.includes('Unable to load page') || 
                         error.message?.includes('refresh your browser');
    
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-md">
          <h2 className="text-xl font-bold text-red-600 mb-2">
            {isChunkError ? 'Unable to Load Page' : 'Component Not Found'}
          </h2>
          <p className="text-gray-600 mb-4">{error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }

  if (!Component) {
    return null;
  }

  return <Component />;
};

export default FunnelRoute;